"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendableEthersLiquity = void 0;
const sendTransaction = (tx) => tx.send();
/**
 * Ethers-based implementation of {@link @liquity/lib-base#SendableLiquity}.
 *
 * @public
 */
class SendableEthersLiquity {
    constructor(populatable) {
        this._populate = populatable;
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.openTrove} */
    async openTrove(assetAddress, params, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTrove(assetAddress, params, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.closeTrove} */
    closeTrove(assetAddress, overrides) {
        return this._populate.closeTrove(assetAddress, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.adjustTrove} */
    adjustTrove(assetAddress, params, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .adjustTrove(assetAddress, params, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.depositCollateral} */
    depositCollateral(assetAddress, amount, overrides) {
        return this._populate.depositCollateral(assetAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawCollateral} */
    withdrawCollateral(assetAddress, amount, overrides) {
        return this._populate.withdrawCollateral(assetAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.borrowSLSD} */
    borrowSLSD(assetAddress, amount, maxBorrowingRate, overrides) {
        return this._populate.borrowSLSD(assetAddress, amount, maxBorrowingRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.repaySLSD} */
    repaySLSD(assetAddress, amount, overrides) {
        return this._populate.repaySLSD(assetAddress, amount, overrides).then(sendTransaction);
    }
    /** @internal */
    setPrice(price, overrides) {
        return this._populate.setPrice(price, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.liquidate} */
    liquidate(assetAddress, address, overrides) {
        return this._populate.liquidate(assetAddress, address, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.liquidateUpTo} */
    liquidateUpTo(assetAddress, maximumNumberOfTrovesToLiquidate, overrides) {
        return this._populate
            .liquidateUpTo(assetAddress, maximumNumberOfTrovesToLiquidate, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.depositSLSDInStabilityPool} */
    depositSLSDInStabilityPool(spAddress, amount, frontendTag, overrides) {
        return this._populate
            .depositSLSDInStabilityPool(spAddress, amount, frontendTag, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawSLSDFromStabilityPool} */
    withdrawSLSDFromStabilityPool(spAddress, amount, overrides) {
        return this._populate.withdrawSLSDFromStabilityPool(spAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawGainsFromStabilityPool} */
    withdrawGainsFromStabilityPool(spAddress, overrides) {
        return this._populate.withdrawGainsFromStabilityPool(spAddress, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.transferCollateralGainToTrove} */
    transferCollateralGainToTrove(spAddress, assetAddress, overrides) {
        return this._populate.transferCollateralGainToTrove(spAddress, assetAddress, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendSLSD} */
    sendSLSD(toAddress, amount, overrides) {
        return this._populate.sendSLSD(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendPSY} */
    sendPSY(toAddress, amount, overrides) {
        return this._populate.sendPSY(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.redeemSLSD} */
    redeemSLSD(assetAddress, amount, maxRedemptionRate, overrides) {
        return this._populate.redeemSLSD(assetAddress, amount, maxRedemptionRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.claimCollateralSurplus} */
    claimCollateralSurplus(assetAddress, overrides) {
        return this._populate.claimCollateralSurplus(assetAddress, overrides).then(sendTransaction);
    }
    async approveAsset(assetAddress, allowance, overrides) {
        return this._populate
            .approveAsset(assetAddress, allowance, overrides)
            .then(sendTransaction);
    }
    /** @internal */
    _mintAsset(amount, assetAddress, address, overrides) {
        return this._populate._mintAsset(amount, assetAddress, address, overrides).then(sendTransaction);
    }
}
exports.SendableEthersLiquity = SendableEthersLiquity;
//# sourceMappingURL=SendableEthersLiquity.js.map